import React, { Component } from 'react';
import { Form, Header, Segment } from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { fetchAcademicYears } from '../../../Lookups/util';
import { fetchSemesters } from '../../../StudentService/StudentServiceInputGrades/InputGradesFilterStudents';
import ExamRegistration from './ExamRegistration';
import moment from 'moment';

class ExamRegistrationAdminPanel extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            semesterKey: null,
            academicYearId: null,
            loading: true
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchUngradedCourseImplementations = this.fetchUngradedCourseImplementations.bind(this);
        this.fetchExamOptionsByCourseImplementation = this.fetchExamOptionsByCourseImplementation.bind(this);
    }

    componentDidMount() {
        axios.all([fetchAcademicYears(), fetchSemesters()])
            .then(axios.spread((yearsRes, semRes) => {
                const academicYears = yearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                })).reverse();

                const semesters = semRes.data.filter(e => e.name.name !== 'ostalo').map(el => ({
                    key: el.name._key, value: el.name._key, text: el.name.name
                }));

                this.setState(
                    {
                        academicYears,
                        semesters,
                        semesterKey: semesters[0].value

                    },
                    () => {
                        axios.get('/academic-years/current')
                            .then(res => {
                                this.setState({ academicYearId: res.data.id }, () => { this.fetchUngradedCourseImplementations(); });
                            });
                    }
                );
            }))
            .catch(err => {
                console.log('Failed to fetch academic year or semesters or faculties.');
            });
    }

    fetchExamOptionsByCourseImplementation(courseImplemenationId) {
        axios.get(`/exams/graded-activities/${this.state.academicYearId}/${courseImplemenationId}`)
            .then(res => {
                this.setState({
                    examOptions: res.data.map(el => (
                        {
                            key: el.gradedActivityId, value: el.gradedActivityId, text: moment(el.gradedActivityDate).format('D. M. YYYY. - HH:mm') + ' | ' + el.gradedActivityName
                        }
                    ))
                });
            });
    }

    fetchUngradedCourseImplementations() {
        let student = JSON.parse(localStorage.getItem('student'));

        let docFilter = {
            semesterKey: this.state.semesterKey,
            academicYearId: this.state.academicYearId,
            studentStudyProgramId: student.studentStudyProgramId ? student.studentStudyProgramId : student.id
        };

        axios.post('/grade-student/ungraded/course-implementations/', { ...docFilter })
            .then(res => {
                this.setState({
                    ungradedCourseImplementations: res.data.map((el) => ({
                        ...el,
                        key: el.courseImplementationId,
                        value: { courseImplementationId: el.courseImplementationId, studentCourseImplementationId: el.studentCourseImplementationId },
                        text: el.courseBasicName
                    })),
                    data: res.data,
                    loading: false,
                    update: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value,
            update: true
        }, () => {
            if (name === 'semesterKey') { this.fetchUngradedCourseImplementations(); localStorage.setItem('semesterKey', value); }
            if (name === 'academicYearId') { this.fetchUngradedCourseImplementations(); localStorage.setItem('academicYearId', value); }
        });
    }

    render() {
        const { semesterKey, academicYearId } = this.state;
        const { hideHeader, hideSegments } = this.props;
        const student = JSON.parse(localStorage.getItem('student'));
        return (
            <div>
                {!hideHeader && <h1>Prijava ispita</h1>}
                <Segment.Group raised={!hideSegments}>
                    {!hideSegments && <Segment>
                        <Header as="h3">
                            {student.firstName} {student.lastName} - {student.index}
                            <Header.Subheader>
                                Ime i prezime studenta, index
                            </Header.Subheader>
                        </Header>
                    </Segment>}
                    <Segment>
                        <Form>

                            <Form.Group widths="equal">

                                <Form.Field required>
                                    <label>Akademska godina</label>
                                    <Form.Dropdown
                                        placeholder="Odaberite akademsku godinu"
                                        value={academicYearId}
                                        onChange={this.handleInputChange}
                                        name="academicYearId"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                        error={this.state.academicYearErr}
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label>Semestar</label>
                                    <Form.Dropdown
                                        placeholder="Odaberite semestar"
                                        value={semesterKey}
                                        onChange={this.handleInputChange}
                                        name="semesterKey"
                                        options={this.state.semesters}
                                        search
                                        fluid
                                        selection
                                        error={this.state.semesterErr}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        <Segment secondary> <ExamRegistration
                            update={this.state.update}
                            semester={this.state.semesterKey}
                            examOptions={this.state.examOptions}
                            ungradedCourseImplementations={this.state.ungradedCourseImplementations}
                            fetchUngradedCourseImplementations={this.fetchUngradedCourseImplementations}
                            fetchExamOptionsByCourseImplementation={this.fetchExamOptionsByCourseImplementation}
                        />
                        </Segment>
                        {/* <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} defaultActiveIndex={2} onTabChange={this.handleTabChange} /> */}
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}

export default ExamRegistrationAdminPanel;



// WEBPACK FOOTER //
// ./src/views/Admin/Students/ExamRegistration/ExamRegistrationAdminPanel.js